import React from "react";
import MonthlyTimeTable from "../MonthlyTimeTable";

const DecemberSehriIftaar = ({districtDetails}) => {
  return <MonthlyTimeTable month={12} title="December Sehri Iftar" columnKey="3Columns" districtDetails={districtDetails} />;
};

export default DecemberSehriIftaar;
